import { render, staticRenderFns } from "./GrandChildren.vue?vue&type=template&id=4faef532"
import script from "./GrandChildren.vue?vue&type=script&lang=ts"
export * from "./GrandChildren.vue?vue&type=script&lang=ts"
import style0 from "./GrandChildren.vue?vue&type=style&index=0&id=4faef532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports